export interface TemporadaJSON {
  tem_id: string | null;
  tem_descripcion: string;
  tem_actual: any;
  tem_fecha_inicio: Date | null;
  tem_fecha_finalizacion: Date | null;
  tem_temid_anterior: string;
}

export class Temporada {
  protected constructor(
    private id: string | null,
    private descripcion: string,
    private actual: any,
    private fechaInicio: Date | null,
    private fechaFinalizacion: Date | null,
    private temidAnterior: string
  ) {}

  static createFrom(
    id: string | null,
    descripcion: string,
    actual: any,
    fechaInicio: Date | null,
    fechaFinalizacion: Date | null,
    temidAnterior: string
  ) {
    return new this(id, descripcion, actual, fechaInicio, fechaFinalizacion, temidAnterior);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: Temporada) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: TemporadaJSON) {
    return Temporada.createFrom(
      entity.tem_id,
      entity.tem_descripcion,
      entity.tem_actual,
      entity.tem_fecha_inicio ? new Date(entity.tem_fecha_inicio) : new Date(),
      entity.tem_fecha_finalizacion ? new Date(entity.tem_fecha_finalizacion) : new Date(),
      entity.tem_temid_anterior
    );
  }

  toJSON(): TemporadaJSON {
    return {
      tem_id: this.getId(),
      tem_descripcion: this.getDescripcion(),
      tem_actual: this.getActual(),
      tem_fecha_inicio: this.getFechaInicio(),
      tem_fecha_finalizacion: this.getFechaFinalizacion(),
      tem_temid_anterior: this.getTemidAnterior(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getDescripcion(): string {
    return this.descripcion;
  }

  getActual(): any {
    return this.actual;
  }

  getFechaInicio(): Date | null {
    return this.fechaInicio;
  }

  getFechaFinalizacion(): Date | null {
    return this.fechaFinalizacion;
  }

  getTemidAnterior(): string {
    return this.temidAnterior;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setDescripcion(value: string): void {
    this.descripcion = value;
  }

  setActual(value: any): void {
    this.actual = value;
  }

  setFechaInicio(value: Date): void {
    this.fechaInicio = value;
  }

  setFechaFinalizacion(value: Date): void {
    this.fechaFinalizacion = value;
  }

  setTemidAnterior(value: string): void {
    this.temidAnterior = value;
  }
}
